import { AvailabilityRequiredData } from './availability.model';

export const getAvailabilityKey = (availability: AvailabilityRequiredData) => `${availability.user_id}|${availability.date}`;
